import { Component, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-device-not-found',
  templateUrl: './device-not-found.component.html',
  styleUrls: ['./device-not-found.component.scss'],
})
export class DeviceNotFoundComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
